import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Collapse, Row, Col } from 'antd';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';
import { ProductListDataService } from 'src/app/products/products/list/product-list.data';
import { TextView } from 'src/core/ui/text.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductTypeEditorController } from 'src/app/products/products/parts/product-type-editor.controller';
import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { Link } from 'react-router-dom';

interface State {
	filter: ProductFilter,

}
interface ProductFilterModalViewProps extends ComponentViewProps<DataSet<ProductSummary>> {
	onSearchProduct: (filter: ProductFilter) => Promise<void>
	onSelectProduct: (product: ProductSummary) => void;
	showResult: boolean;
	selectionKey: string
	itinerary: TourItineraryProductItem
}

@observer
export class ProductFilterModalView extends React.Component<ProductFilterModalViewProps, State> {

	constructor(props) {
		super(props);

		this.state = {
			filter: {
				searchKeywords: null,
				code: null,
				productType: null,
				categoryId: null,
				regionId: null,
				placeId: null,
			}
		};
	}


	componentWillReceiveProps(nextProps: Readonly<ProductFilterModalViewProps>, nextContext: any) {
		if (nextProps.selectionKey == null) {
			this.setState({
				filter: {
					searchKeywords: null,
					code: null,
					productType: null,
					categoryId: null,
					regionId: null,
					placeId: null,
				}
			})
		}
	}
	renderFilters = (filter: ProductFilter): JSX.Element => {
		let filterRows = [];
		return <React.Fragment>
			<Row gutter={16}>
				<Col xs={24}>
					<TextView
						mode='edit'
						label={null}
						value={filter.searchKeywords}
						onChanged={(newValue) => {
							filter.searchKeywords = newValue
							this.setState({
								filter: filter
							})
						}}
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col xs={24}>
					<TextView
						mode='edit'
						label="Code"
						value={filter.code}
						onChanged={(newValue) => {
							filter.code = newValue;
							this.setState({
								filter: filter
							})
						}}
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col xs={12}>
					<ProductTypeEditorController
						label="Product Type"
						mode='edit'
						value={filter.productType}
						onChanged={(newValue) => {
							filter.productType = newValue;
							filter.categoryId = undefined;
							this.setState({
								filter: filter
							})
						}}
						options={
							[
								{ value: 0, label: 'General' },
								{ value: 1, label: 'Accomodation' },
								{ value: 2, label: 'Car Rent' },
								{ value: 3, label: 'Transfer' },
								{ value: 4, label: 'Flight' },
								{ value: 5, label: 'Room' },
							]
						}
						setBusy={this.props.setBusy}
					/>
				</Col>
				<Col xs={12}>
					<ProductCategoryEditorController
						label="Category"
						mode={filter.productType != null ? "edit" : "display"}
						value={filter.categoryId}
						productType={filter.productType}
						onChanged={(newValue) => {
							let value = newValue != null ? newValue.id : null;
							filter.categoryId = value;
							this.setState({
								filter: filter
							})
						}}
						setBusy={this.props.setBusy}
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col xs={12}>
					<RegionEditorController
						label="Region"
						mode='edit'
						value={filter.regionId}
						onChanged={(newValue) => {
							const id = newValue != null ? newValue.id : null;
							filter.regionId = id;
							filter.placeId = undefined;
							this.setState({
								filter: filter
							})

						}}
						setBusy={this.props.setBusy}
					/>
				</Col>
				<Col xs={12}>
					<PlaceEditorController
						label="Place"
						mode={filter.regionId ? "edit" : "display"}
						value={filter.placeId}
						onChanged={(newValue) => {
							const id = newValue != null ? newValue.id : null;
							filter.placeId = id;
							this.setState({
								filter: filter
							})
						}}
						setBusy={this.props.setBusy}
						regionId={filter.regionId}
					/>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col xs={24}>
					<Button
						type="primary"
						style={{ minWidth: 'auto', width: '40px' }}
						onClick={() => {
							this.props.setBusy(true);
							this.props.onSearchProduct(filter).then(() => {
								this.props.setBusy(false);
							});
						}}
						icon={"search"}
					>

					</Button>
				</Col>
			</Row>
		</React.Fragment>
	}
	onChangeSelection = (selectedRowKeys: string[] | number[], selectedRows: Object[]) => {
		if (selectedRowKeys.length > 0) {
			let id = selectedRowKeys[selectedRowKeys.length-1].toString();
			let product = this.props.model.items.find(p => p.id.toString() == id);
			if (product)
				this.props.onSelectProduct(product);
		}


	}
	render() {
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: ProductSummary) => <Link to={`/products/products/${record.id}`}>{text}</Link>,
			},
			{
				key: 'code',
				title: 'Code',
				dataIndex: 'code',

			},
			{
				key: 'productType',
				title: 'Type',
				dataIndex: 'productTypeText',

			},
			{
				key: 'categoryDisplayName',
				title: 'Category',
				dataIndex: 'categoryDisplayName',

			},
			{
				key: 'regionDisplayName',
				title: 'Region',
				dataIndex: 'regionDisplayName',

			},
			{
				key: 'placeDisplayName',
				title: 'Place',
				dataIndex: 'placeDisplayName',

			}
		];
		const { filter } = this.state;
		return <div className="card p-3 card-borderless">
			<Collapse bordered={false} defaultActiveKey={this.props.showResult == true && this.props.model ? ['1', '2'] : ['1']} >
				<Collapse.Panel key="1" header={`Filters`}>
					{this.renderFilters(filter)}
				</Collapse.Panel>
			</Collapse>
			{this.props.showResult == true && this.props.model && <div className="panel">
				<h3>{`Result (${this.props.model.items.length})`}</h3>
				<DataTableView
					setBusy={this.props.setBusy}
					rowKey={(product: ProductSummary) => product.id.toString()}
					columns={columns}
					model={this.props.model}
					hideToolbar={ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hideSearch}
					hierarchyParent={['parentProductId']}
					hierarchyHasChildren={(item) => item.hasChildren}
					hierarchyId={['id']}
					selection={{
						selectedRowKeys: this.props.selectionKey ? [this.props.selectionKey] : [],
						onChange: this.onChangeSelection,
					}
					}
				/>
			</div>}
		</div>;
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-filter-modal.view.tsx